<template>
  <div class="app-container">
    <table border="0" cellspacing="0" cellpadding="0">
      <tr>
        <th>用户名</th>
        <td>{{ msg.user_name }}</td>
        <th>订单编号</th>
        <td>{{ msg.order_sn }}</td>
        <th>下单时间</th>
        <td>{{ msg.create_time }}</td>
      </tr>
      <tr>
        <th>用户头像</th>
        <td>
          <el-image style="width: 100px; height: 100px" :src="msg.user_avatar" :preview-src-list="[msg.user_avatar]">
          </el-image>
        </td>
        <th>直播名称</th>
        <td>{{ msg.live_title }}</td>
        <th>订单状态</th>
        <td>
          {{ msg.order_state_txt || ["待付款", "已付款", "", "", "", "", "已取消"][msg.order_state] }}
        </td>
      </tr>
      <tr>
        <th>手机</th>
        <td>{{ msg.mobile }}</td>
        <th>订单金额</th>
        <td>{{ msg.order_money }}</td>
        <th>付款方式</th>
        <td>
          {{ ["", "支付宝", "微信", "对公打款", "线下支付", "免费"][msg.pay_type] }}
        </td>
      </tr>
      <tr v-if="msg.pay_type == 3">
        <th>付款凭证</th>
        <td>
          <el-image
            style="width: 100px; height: 100px"
            :src="msg.pay_img"
            placeholder="付款凭证"
            :preview-src-list="[msg.pay_img]"
          >
            <span></span>
          </el-image>
        </td>
      </tr>
    </table>

    <!-- <div v-if="msg.pay_type==3" style="margin: 20px;width: 200px;height: 100px;background-color: #f5f5f5; text-align: center;">付款凭证</div> -->
    <el-dialog title="取消订单" :visible.sync="cancelbox" width="30%" center :before-close="closeCancelbox">
      <div class="flex-row">
        <span><i style="color: red">*</i>取消原因</span><el-input v-model="cancel_mark" type="textarea"></el-input>
      </div>
      <div class="flex-row">
        <span><i style="color: red">*</i>退款金额</span><el-input v-model="cancel_price" type="text"></el-input>
      </div>

      <span slot="footer" class="dialog-footer">
        <el-button @click="closeCancelbox">取 消</el-button>
        <el-button type="primary" @click="confirmCancel">确 定</el-button>
      </span>
    </el-dialog>
    <div style="padding: 20px">
      <el-button v-show="msg.order_state == 0" type="primary" @click="subPay(msg)">支付确认</el-button>
      <el-button
        v-if="msg.order_state != 6 && msg.pay_type != 5 && msg.order_money - 0 != 0"
        type="primary"
        @click="cancelOrdel(msg)"
        >取消订单</el-button
      >
    </div>
  </div>
</template>

<script>
import { editPay, getOrderDetail } from "@/api/live.js";
export default {
  data() {
    return {
      msg: {},
      cancel_mark: "",
      cancel_price: "",
      cancelbox: false,
      actrow: {},
    };
  },
  mounted() {
    this.querys = this.$route.query;
    if (this.querys.order_id) {
      this.getDetail(this.querys.order_id);
    } else {
      this.$message.error("未识别的订单");
    }
  },
  methods: {
    editPay(data) {
      editPay(data, this.actrow.order_id).then((res) => {
        if (res == true) {
          this.closeCancelbox();
          this.actrow = {};
          this.getDetail(this.querys.order_id);
          this.$message.success("成功");
        } else {
          this.$message.error("失败");
        }
      });
    },
    confirmCancel() {
      if (!this.cancel_mark) {
        this.$message.warning("请输入取消原因");
        return;
      }
      if (!this.cancel_price) {
        this.$message.warning("请输入取消金额");
        return;
      }
      if (!(this.cancel_price - 0 >= 0)) {
        this.$message.warning("退款金额需要大于0");
        return;
      }
      if (this.cancel_price - 0 > this.actrow.order_money - 0) {
        this.$message.warning("退款金额不能大于订单金额");
        return;
      }
      this.editPay({
        operating_type: 3,
        cancel_mark: this.cancel_mark,
        cancel_price: this.cancel_price,
      });
    },
    closeCancelbox() {
      this.cancelbox = false;
      this.cancel_mark = "";
    },
    cancelOrdel(row) {
      this.cancelbox = true;
      this.cancel_price = row.order_money - 0;
      this.actrow = row;
    },
    subPay(row) {
      this.actrow = row;
      this.$confirm("确认该订单已支付？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.editPay({ operating_type: 2, pay_state: 1 });
        })
        .catch(() => {});
    },
    handleChange(val) {
      console.log(val);
    },
    async getDetail(id) {
      // this.msg = this.$route.query
      // return
      const res = await getOrderDetail(id);
      if (res) {
        this.msg = res;
      } else {
        this.msg = this.$route.query;
      }
      console.log(res);
    },
  },
};
</script>
<style>
.el-collapse-item__header {
  background-color: #f5f5f5;
  text-indent: 10px;
}
</style>
<style scoped="scoped" lang="less">
table {
  width: 100%;
}
h3 {
  line-height: 60px;
  border-bottom: 1px solid #bbb;
}
.course {
  padding: 10px 20px;
  display: flex;
  p {
    width: 50%;
  }
  span {
    color: #999;
    width: 10%;
  }
}
.flex-row {
  display: flex;
  align-items: center;
  margin-bottom: 20px;
  span {
    white-space: nowrap;
    margin-right: 20px;
  }
}
</style>
